export default {
    scope: 'body',
    defaults: {
        scoreboard: {
            pageName: '@PAGE_NAME@: Scoreboard: Scores',
            events: 'event77,event4,event91,event92,event93,event94,event95',
            channel: 'Scoreboard',
            prop1: 'Scoreboard',
            prop11: 'Dynamic Page View',
            prop13: '@PAGE_NAME@: Scoreboard: Scores',
            prop71: '@LANG@'
        },
        schedule: {
            pageName: '@PAGE_NAME@: Schedule: MiLB Schedule',
            events: 'event77,event4,event91,event92,event93,event94,event95',
            channel: 'Schedule',
            prop1: 'Schedule',
            prop11: 'Dynamic Page View',
            prop13: '@PAGE_NAME@: Schedule: MiLB Schedule',
            prop71: '@LANG@'
        }
    },
    app: [
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .sns-daypicker-left-arrow',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Left Arrow Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .sns-daypicker-left-arrow',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule:',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Left Arrow Click'
        },
        {
            wire: {
                selector:
                    'section[data-active-view*="scores"] .react-datepicker .react-datepicker__navigation--previous',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Left Arrow Click'
        },
        {
            wire: {
                selector:
                    'section[data-active-view*="schedule"] .react-datepicker .react-datepicker__navigation--previous',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Left Arrow Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .sns-daypicker-right-arrow',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Right Arrow Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .sns-daypicker-right-arrow',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Right Arrow Click'
        },
        {
            wire: {
                selector: 'section[data-active-view*="scores"] .react-datepicker .react-datepicker__navigation--next',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Right Arrow Click'
        },
        {
            wire: {
                selector: 'section[data-active-view*="schedule"] .react-datepicker .react-datepicker__navigation--next',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Right Arrow Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .react-datepicker-wrapper svg',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard Date Picker: Open'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .react-datepicker-wrapper svg',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Open'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .sns-daypicker-day-button',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Date Select Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .react-datepicker-wrapper #pickerInput',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Month and Year Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .sns-daypicker-day-button',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Date Select Click'
        },
        {
            wire: {
                selector: ' #scores-schedule-root section[data-active-view*="schedule"] .react-datepicker-wrapper #pickerInput',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Month and Year Click'
        },
        /* Multiple wires for date click as it spans multiple (third party) component lib components which we cannot
        really apply classes to since they are generated on their own */
        {
            wire: {
                selector: 'section[data-active-view*="scores"] .react-datepicker >div:last-child > button',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Date Select Click'
        },
        {
            wire: {
                selector: 'section[data-active-view*="schedule"] .react-datepicker >div:last-child > button',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Date Select Click'
        },
        {
            wire: {
                selector: 'section[data-active-view*="scores"] .react-datepicker .react-datepicker__day',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Date Select Click'
        },
        {
            wire: {
                selector: 'section[data-active-view*="schedule"] .react-datepicker .react-datepicker__day',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Date Select Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-watchArchive',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: MLB.tv Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-watchArchive',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: MLB.tv Click',
            prop40: '@SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-box',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Box Score Click',
            prop40: 'Gameday: @SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-box',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule:',
            prop14: '@PAGE_NAME@: Schedule: Box Score Click',
            prop40: 'Gameday: @SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-highlights',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Gameday Highlights Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-cheer',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Cheer Button Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-highlights',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Gameday Highlights Click',
            prop40: '@SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-gameday',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Gameday Click',
            prop40: 'Gameday: @SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .iUhipB',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Gameday Click',
            prop40: 'Gameday: @SCORES_AWAY_CLUB_NAME_MOBILE@ at @SCORES_HOME_CLUB_NAME_MOBILE@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-gameday',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Gameday Click',
            prop40: 'Gameday: @SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-preview',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Preview Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-preview',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Preview Click',
            prop40: '@SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-button_mlbtv',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: MLB.tv Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-button_mlbtv',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: MLB.tv Click',
            prop40: '@SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-tickets',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Tickets Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-tickets',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Tickets Click',
            prop40: '@SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .trk-wrap',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Wrap Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .iJFPnM .lcFuuA',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Player Select Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop3: '@PLAYER_ID@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .lltnTv .lcFuuA, #scores-schedule-root section[data-active-view*="scores"] .jPCzPZ .lcFuuA',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Team Select Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop51: '@GAME_STATUS@',
            eVar51: '@TEAM_NAME@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .cbqBls .lcFuuA',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Player Select Click',
            prop40: '@SCORES_AWAY_CLUB_NAME@ at @SCORES_HOME_CLUB_NAME@: @GAME_DATE@',
            prop3: '@PLAYER_ID@',
            prop51: '@GAME_STATUS@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .trk-wrap',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Wrap Click',
            prop40: 'Gameday: @SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .mobile-compact',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Grid View Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .mobile-compact',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Grid View Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="scores"] .mobile-expanded',
                defaults: 'scoreboard',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Scoreboard',
            prop14: '@PAGE_NAME@: Scoreboard: Date Picker: Card View Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .mobile-expanded',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule:',
            prop14: '@PAGE_NAME@: Schedule: Date Picker: Card View Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .playermatchup-preview',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Player Click - Probable',
            prop40: '@SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .playermatchup-live',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Player Click - Live',
            prop40: 'Gameday: @SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .playermatchup-final',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Player Click - Decision',
            prop40: 'Gameday: @SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .teammatchup-teaminfo a',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Club Site Click'
        },
        {
            wire: {
                selector: '#scores-schedule-root section[data-active-view*="schedule"] .gameinfo-gamedaylink',
                defaults: 'schedule',
                eventType: 'mousedown'
            },
            prop12: '@PAGE_NAME@: Schedule',
            prop14: '@PAGE_NAME@: Schedule: Gameday Link Click',
            prop40: 'Gameday: @SCHEDULE_AWAY_CLUB_NAME@ at @SCHEDULE_HOME_CLUB_NAME@: @GAME_DATE@'
        }
    ]
};
